import wire from '../wire';

let module = wire(
  'embed',
  ``,
  () => {
    // Migrated to dashboard_vue
    window.location.href = `${window.VUE_DASHBOARD_ROOT}/embed`;
  },
  'EmbedController'
);

require('./embed-directive');

export default module;



// WEBPACK FOOTER //
// ./app/pages/embed/_index.js